export var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["KO"] = "ko_KR";
    LANGUAGE["EN"] = "en_US";
    LANGUAGE["CH"] = "cn_CH";
})(LANGUAGE || (LANGUAGE = {}));
